import { render, staticRenderFns } from "./navigation-component.vue?vue&type=template&id=0cf8a14d"
import script from "./navigation-component.vue?vue&type=script&lang=ts"
export * from "./navigation-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports